import React from 'react';
import PropTypes from 'prop-types';
import EventPageContent from '../../components/EventPageContent';
import { keysToCamelFromSnake } from '../../utils/caseconverters';
import { basePageWrap } from '../BasePage';
import styles from './EventDetail.module.scss';

const EventDetail = (props) => {
    const camelProps = keysToCamelFromSnake(props);
    const { related, event } = camelProps;

    const formattedEvent = event
        ? {
              ...event,
              startDate: new Date(event.startDate),
              endDate: new Date(event.endDate),
          }
        : null;

    return (
        <div className={styles['EventDetail']}>
            {formattedEvent && (
                <EventPageContent {...formattedEvent} related={related} />
            )}
        </div>
    );
};

EventDetail.propTypes = {
    contentBlocks: PropTypes.array,
};

export default basePageWrap(EventDetail);
